import user_api from '@/api/user';
import { request_list, upload_file } from '@/commons/hpod';
import { refreshResource } from "@/commons/utils";
import moment from 'moment';
import Vue from 'vue';

const state = {
    contactCareExpired: null,
    requestWithdraw: null,
    financeSummary: null,
    date_range: [],
    period_date: [],
    compare_date: false,
    allowCompare: false,
    start_time: undefined,
    end_time: undefined,
    compare_start_time: undefined,
    compare_end_time: undefined,
    rangeSelect: '',
    rangeSelectCompare: '',
    all_users: [],
    stores: [],
    chinaStores: [],
    tranferStores: [],
    provinces: [],
    districts: [],
    communes: [],
    sidebarExpanded: true,
    orderWidgetSettings: {
        customer: true,
        staff: true,
        product: true,
        chat: true,
        paymentHistory: true,
        paymentArea: true,
        complain: true,
        changeHistory: true,
        transaction: true,
    },
    filters: {
        "staff_list": [],
        "product_list": []
    },
    filterConditions: {
        "staff_list": [],
        "product_list": []
    }
};

const getters = {};

const actions = {
    getAllUsers({ commit }) {
        user_api.getAllUsers(res => {
            commit('setAllUsers', res);
        }, Vue.http, this.state.authentication.token);
    },
    getAllStores({ commit }) {
        request_list('stores', data => {
            commit('setListStores', data);
        }, Vue.http, {}, this.state.authentication.token);
    },
    getAllChinaStores({ commit }) {
        request_list('chinastores', data => {
            commit('setListChinaStores', data);
        }, Vue.http, {}, this.state.authentication.token);
    },
    getAllTranferStores({ commit }) {
        request_list('tranferstores', data => {
            commit('setListTranferStores', data);
        }, Vue.http, {}, this.state.authentication.token);
    },
    setDateRange({commit }, date_range_val) {
        commit('setDates', date_range_val);
    },
    setPeriodDates({commit }, date_range_val) {
        commit('setPeriodDates', date_range_val);
    },
    setCompareDate({commit }, compare_date_val) {
        commit('setCompareDate', compare_date_val);
    },
    setRangeSelect({commit }, rangeSelectVal) {
        commit('setRangeSelect', rangeSelectVal);
    },
    setRangeSelectCompare({commit }, rangeSelectCompareVal) {
        commit('setRangeSelectCompare', rangeSelectCompareVal);
    },
    setOrderWidgets({commit }, { widgets }) {
        commit('setOrderWidgets', { widgets });
    },
    getExpiredContactCare({ commit }) {
        request_list('contact-care/expired', data => {
            commit('setExpiredContactCare', data);
        }, Vue.http, {}, this.state.authentication.token);
    },
    getRequestWithdraw({ commit }, params) {
        request_list('withdraw/count', data => {
            commit('setRequestWithdraw', data);
        }, Vue.http, params, this.state.authentication.token);
    },
    getFinanceSummary({ commit }, params) {
        request_list('finance_summary/count', data => {
            commit('setFinanceSummary', data);
        }, Vue.http, params, this.state.authentication.token);
    },
    upload_media_file({ commit }, formData) {
        upload_file("commons", res => {
            refreshResource();
        }, Vue.http, formData, this.state.authentication.token, 'upload-file');
    },
    getProvinces({ commit }) {
        Vue.http.get(`https://pos.pages.fm/api/v1/geo/provinces`).then(function (res) {
            commit('setListProvinces', res.data);
        });
    },
    getDistricts({ commit }, param) {
        Vue.http.get(`https://pos.pages.fm/api/v1/geo/districts?province_id=${param}`).then(function (res) {
            commit('setListDistricts', res.data);
        });
    },
    getCommunes({ commit }, param) {
        Vue.http.get(`https://pos.pages.fm/api/v1/geo/communes?district_id=${param}`).then(function (res) {
            commit('setListCommunes', res.data);
        });
    },
};

const mutations = {
    setAllUsers(state, res) {
        state.all_users = res.data || [];
    },
    setListStores(state, res) {
        state.stores = res.data || [];
    },
    setListProvinces(state, res) {
        state.provinces = res.data || [];
        for (let i = 0; i < state.provinces.length; i++) {
            const element = state.provinces[i];
            element.id = Number(element.id);
        }
    },
    setListDistricts(state, res) {
        state.districts = res.data || [];
        for (let i = 0; i < state.districts.length; i++) {
            const element = state.districts[i];
            element.id = Number(element.id);
            element.province_id = Number(element.province_id);
        }
    },
    setListCommunes(state, res) {
        state.communes = res.data || [];
        for (let i = 0; i < state.communes.length; i++) {
            const element = state.communes[i];
            element.id = Number(element.id);
            element.district_id = Number(element.district_id);
            element.province_id = Number(element.province_id);
        }
    },
    setListChinaStores(state, res) {
        state.chinaStores = res.data || [];
    },
    setListTranferStores(state, res) {
        state.tranferStores = res.data || [];
    },
    setOrderWidgets(state, { widgets }) {
        state.orderWidgets = widgets;
    },
    setSidebarExpanded(state, { expanded }) {
        state.sidebarExpanded = expanded;
    },
    setFilters(state, { filter }) {
        state.filters = filter;
    },
    setFilterConditions(state, { filter }){
        state.filterConditions = filter;
    },
    setDates(state, date_range_val) {
        state.start_time = moment(date_range_val[0]).startOf('d').add(60 * moment().utcOffset(), 'seconds').unix();
        state.end_time = moment(date_range_val[1]).endOf('d').add(60 * moment().endOf('d').utcOffset(), 'seconds').unix();

        state.date_range = date_range_val;
    },
    setPeriodDates(state, val) {
        state.compare_start_time = moment(val[0]).startOf('d').add(60 * moment().utcOffset(), 'seconds').unix();
        state.compare_end_time = moment(val[1]).endOf('d').add(60 * moment().endOf('d').utcOffset(), 'seconds').unix();

        state.period_date = val;
    },
    setCompareDate(state, compare_date_val) {
        state.compare_date = compare_date_val;
        if(!compare_date_val){
            state.period_date = [];
            state.compare_start_time = null;
            state.compare_end_time = null;
        }
    },
    setRangeSelect(state, rangeSelectVal) {
        state.rangeSelect = rangeSelectVal;
    },
    setRangeSelectCompare(state, rangeSelectCompareVal) {
        state.rangeSelectCompare = rangeSelectCompareVal;
    },
    setExpiredContactCare(state, res) {
        state.contactCareExpired = res.data || null;
    },
    setRequestWithdraw(state, res) {
        state.requestWithdraw = res.data || null;
    },
    setFinanceSummary(state, res) {
        state.financeSummary = res.data || null;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
